module.exports = __webpack_public_path__ + "static/media/star8.4f42f236.svg";